import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  Switch,
  Input,
  Form,
  Modal,
  message,
  InputNumber,
  Tooltip,
} from "antd";
import { quickMessage as quickMessageApi } from "../../apis";
import { RowAction } from "../../components";

export default function QuickMessages() {
  const [rows, setRows] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [form] = Form.useForm();

  const load = async () => {
    const res = await quickMessageApi.list();
    setRows(res.rows);
  };

  useEffect(() => {
    load();
  }, []);

  const onToggle = async (id) => {
    await quickMessageApi.toggle(id);
    load();
  };

  const onDelete = async (id) => {
    await quickMessageApi.remove(id);
    message.success("Deleted successfully");
    load();
  };

  const onSubmit = async (values) => {
    if (selected?._id) {
      await quickMessageApi.update(selected._id, values);
      message.success("Updated successfully");
    } else {
      await quickMessageApi.create(values);
      message.success("Created successfully");
    }
    setModalOpen(false);
    form.resetFields();
    load();
  };

  const onEdit = (row) => {
    setSelected(row);

    form.setFieldsValue({
      title      : row.title,
      description: row.description,
      sort       : row.sort,
    });
    setModalOpen(true);
  };

  const onCreate = () => {
    setSelected(null);

    form.resetFields();
    form.setFieldsValue({
      sort: 1,
    });
    setModalOpen(true);
  };

  const columns = [
    {
      title    : "表示順",
      dataIndex: "sort",
      width    : 80,
    },
    {
      title    : "タイトル",
      dataIndex: "title",
    },
    {
      title : "メッセージ",
      render: (record) => {
        return <Tooltip placement='topRight' overlayStyle={{
          maxWidth: 1200,
        }} autoAdjustOverflow title={record.description}>
          <div
            style={{
              width       : 500,
              overflow    : "hidden",
              textOverflow: "ellipsis",
              whiteSpace  : "nowrap",
            }}
          >
            {record.description}
          </div>
        </Tooltip>;
      },
    },
    {
      title : "操作",
      width : 120,
      render: (_, row) => {
        let actions = {
          edit  : "編集",
          delete: "削除",
        };

        if (row.isActive) {
          actions = {
            ...actions,
            deactivate: "非表示",
          };
        } else {
          actions = {
            ...actions,
            activate: "表示",
          };
        }

        return (
          <RowAction
            actions={actions}
            onClick={(key) => {
              switch (key) {
                case "edit":
                  onEdit(row);
                  break;

                case "activate":
                case "deactivate":
                  onToggle(row._id);
                  break;

                case "delete":
                  Modal.confirm({
                    title  : "メッセージテンプレートを削除する",
                    content: "削除しますか?",
                    onOk   : async () => {
                      await onDelete(row._id);
                    },
                  });
                  break;

                default:
              }
            }}
          />
        );
      },
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display       : "flex",
          justifyContent: "space-between",
          marginBottom  : 16,
        }}
      >
        <h2>クイックメッセージ</h2>
        <Button type="primary" onClick={onCreate}>
          + 作成
        </Button>
      </div>
      <Table rowKey="_id" dataSource={rows} columns={columns} />
      <Modal
        title={selected ? "編集" : "作成"}
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={onSubmit}>
          <Form.Item
            name="title"
            label="タイトル"
            rules={[{ required: true, message: "Title is required" }]}
          >
            <Input placeholder="タイトル" />
          </Form.Item>
          <Form.Item
            name="description"
            label="メッセージ"
            rules={[{ required: true, message: "メッセージが必須" }]}
          >
            <Input.TextArea rows={3} placeholder="メッセージn" />
          </Form.Item>
          <Form.Item
            name="sort"
            label="表示順"
            rules={[{ required: true, message: "表示順をいれてください" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              step={0.1}
              placeholder="1.1"
            />
          </Form.Item>
          <Button type="primary" htmlType="submit" block>
            保存
          </Button>
        </Form>
      </Modal>
    </div>
  );
}
